interface ColorSelectionOptions {
  signal?: AbortSignal;
}

interface ColorSelectionResult {
  sRGBHex: string;
}

interface EyeDropper {
  open: (options?: ColorSelectionOptions) => Promise<ColorSelectionResult>;
}

interface EyeDropperConstructor {
  new (): EyeDropper;
}

declare global {
  interface Window {
    EyeDropper?: EyeDropperConstructor | undefined;
  }
}

export const useEyeDropper = () => {
  const isSupported = () => {
    return 'EyeDropper' in window;
  };

  return {
    open: async () => {
      if (isSupported()) {
        const eyeDropper =
          window.EyeDropper === null || window.EyeDropper === undefined
            ? undefined
            : new window.EyeDropper();
        // eslint-disable-next-line no-return-await
        return await eyeDropper?.open();
      }
    },
  };
};
